import React from "react";
import { WishListDetailBody } from "tsi-common-react/src/apps/customer-account/WishListDetailBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.WishListDetailDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <WishListDetailBody {...props} />
    </PageSkeleton>
);
